/**
 * useRecordings Hook
 * React Query hook for fetching and caching recordings list
 */

import { useQuery } from '@tanstack/react-query';
import { listRecordings } from '../api/recordingsApi';
import type { RecordingsResponse } from '../types/recording';

/**
 * Fetch user's recordings with automatic caching
 * @param page - Page number (default: 1)
 * @param pageSize - Items per page (default: 20)
 * @returns Query result with recordings data
 */
export function useRecordings(page = 1, pageSize = 20) {
  return useQuery<RecordingsResponse, Error>({
    queryKey: ['recordings', page, pageSize],
    queryFn: () => listRecordings(page, pageSize),
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 30, // 30 minutes (formerly cacheTime)
    retry: 2,
  });
}
